module.exports = "data:image/webp;base64,UklGRvIAAABXRUJQVlA4IOYAAACwBQCdASoZABkAPpE+mEiloyIhKA1QsBIJZwDGgaglGxq8M2ysEx2DWzUQeTL0IZIaTvJnBAAA++R04UULLf3GfPhEUIY7RoTFmYYrcW6cSy7QdXwpquufpCYSzPx9hgeXcMKyrlXq8DW9y0Uik5ExUTPB06zo4sc6d2nDlqNBTJ7Zd4ZbzKk2B9lSnEJnIpTpXFGZVd3IV5dZBL1cmXtQDC7TaAOKSRxXszmZeFNfw8IEqBsRgut3yQ8OBVI07JCUSLR3hVdzExxUdISJxd1McRqQkmDSOM9pxtzd9p9511g97AAAAA=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/color/antique-indigo-wash.webp
// module id = x1oq
// module chunks = 14